import { createFileRoute } from '@tanstack/react-router';
import { ImportsRouteView } from '@/pages/workspaces/imports/routing';
import { LastWorkspaceResolver } from './-components';
import { validateDetailSearch } from './-import-detail-search';
import { ImportDetailPage } from './-route-pages';

/** No `appBundle`: this URL has no `journeys` segment for the resolver to rebuild from. */
function ImportDetailRoute() {
  return (
    <LastWorkspaceResolver>
      <ImportsRouteView>
        <ImportDetailPage />
      </ImportsRouteView>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/imports/$importId/')({
  validateSearch: validateDetailSearch,
  component: ImportDetailRoute,
});
